import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect } from 'react';
import "../index.css";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import axios from 'axios';
import Footer from './Common_Components/Footer';
function LearnVocabulary() {
    const navigate = useNavigate();
    const location = useLocation();
    // const { LearningId, dayId, methodType, dayName } = location.state || {};
    const [activePage, setActivePage] = useState("");

    const [isActive, setIsActive] = useState(true);
    const [categoryId, setCategoryId] = useState(null);
    const [quizData, setQuizData] = useState([]);
    const [hasQuizData, setHasQuizData] = useState(false);
    const authToken = localStorage.getItem("AuthToken");

    const LearScriptData = location.state;
    const LearningId = LearScriptData.LearningId;
    const dayId = LearScriptData.dayId;
    const methodType = LearScriptData.methodType;
    console.log("LearnScriptData : ", LearningId, dayId, methodType);

    useEffect(() => {
        let quizCategoryId;
        let quizName;

        switch (methodType) {
            
            case "Learn Vocabulary":
            case "जापानी शब्दावली सीखें":
                quizCategoryId = 45;
                quizName = "Vocab Quiz";
                break;
            case "हिरागाना अभ्यास":
                quizCategoryId = 38;
                quizName = "Hiragana Practice";
                break;
            case "काताकाना अभ्यास":
                quizCategoryId = 43;
                quizName = "Katakana Practice";
                break;
            case "शब्दकोश अभ्यास":
                quizCategoryId = 45;
                quizName = "Vocabulary Practice";
                break;
            default:
                console.log("No matching methodType found.");
                break;
        }

        setCategoryId(quizCategoryId);
    }, [methodType, dayId]);

    useEffect(() => {
        const fetchQuizData = async () => {
            if (!categoryId || !dayId) return;

            try {
                const response = await axios.get(
                    `https://api.japaking.online/api/categories/question/day?categoryId=${categoryId}&dayId=${dayId}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${authToken}`,
                        },
                    }
                );
                if (response.data.success) {
                    const newQuestions = response.data.message.category;
                    setQuizData(prevData => [
                        ...prevData,
                        ...newQuestions.filter(
                            q => !prevData.some(p => p.question_id === q.question_id),
                        ),
                    ]);

                    setHasQuizData(newQuestions.length > 0);
                }
            } catch (error) {
                console.error('Error fetching quiz data:', error);
            }
        };

        fetchQuizData();
    }, [categoryId, dayId]);

    const handleNavigate = () => {
        setIsActive(false);
        navigate('/leacture-video', {
            state: { dayId: dayId }, // Pass LearningId in the state
        });
        console.log("LearningId", dayId);
    };
    const handleNavigateToWritingModule = () => {
        let categoryId;
    
         if (methodType === "Learn Vocabulary") {
          if (dayId >= 1 && dayId <= 21) {
            categoryId = 48;
            setCategoryId(categoryId);
          }
        }
    
        else if (methodType === "जापानी अक्षर सीखें") { 
          if (dayId >= 1 && dayId <= 21) {
            categoryId = 38; 
            setCategoryId(categoryId);
          }
        } else if (methodType === "जापानी शब्दावली सीखें") { 
          if (dayId >= 1 && dayId <= 21) {
            categoryId = 48; 
            setCategoryId(categoryId);
          }
        } else if (methodType === "हिरागाना अभ्यास") { 
          categoryId = 38; 
          setCategoryId(categoryId);
        } else if (methodType === "काताकाना अभ्यास") { 
          categoryId = 43; 
          setCategoryId(categoryId);
        } else if (methodType === "शब्दकोश अभ्यास") { 
          categoryId = 48; 
          setCategoryId(categoryId);
        }
    
        if (categoryId) {
          console.log("This is the category id for navigation", categoryId);

          navigate('/writing-pratice', {
           state:{ categoryId: categoryId,
            dayId: dayId},
          });
        } else {
          console.log("Error: No valid categoryId found.");
        }
      }; 
      const handleNavigateToModuleQuestions = () => {
        let categoryId;
        let quizName;
    
        switch (methodType) {
          
          case "Learn Vocabulary":
            if (dayId >= 0 && dayId <= 20) {
              categoryId = 46; 
              quizName = "Vocab Quiz";
            }
            break;
    
          
          case "जापानी अक्षर सीखें": 
            if (dayId >= 0 && dayId <= 10) {
              categoryId = 37; 
              quizName = "हिरागाना";
            } else if (dayId >= 11 && dayId <= 20) {
              categoryId = 42; 
              quizName = "काताकाना क्विज"; 
            }
            break;
          case "जापानी शब्दावली सीखें": 
            if (dayId >= 0 && dayId <= 20) {
              categoryId = 46; 
              quizName = "शब्दावली क्विज"; 
            }
            break;
          case "हिरागाना अभ्यास":
            categoryId = 37; 
            quizName = "हिरागाना अभ्यास"; 
            break;
          case "काताकाना अभ्यास": 
            categoryId = 42; 
            quizName = "काताकाना अभ्यास"; 
            break;
          case "शब्दकोश अभ्यास": 
            categoryId = 46;
            quizName = "शब्दकोश अभ्यास"; 
            break;
    
          default:
            break;
        }
    
        if (categoryId && quizName) {
          navigate('/take-quiz', {
            state:{ categoryId: categoryId,
            quizName: quizName,
            dayId: dayId},
            
          });

        } else {
         navigate('/take-quiz');
        }
      }; 

    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
                            <h2>Learn Vocabulary</h2>  {/* Display the selected day */}
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="tiles-wrapper">
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                        <button className="learn-vocabulary-content"  onClick={() => handleNavigate("/lecture-video")}>
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/31.png`} alt="Japan Icon" className="learn-vocabulary-icon" />
                                    <h2>Lecture Video</h2>
                                </button>
                                <button className="learn-vocabulary-content" onClick={() => navigate("/study-job-in-japan")}>
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/32.png`} alt="Japan Icon" className="learn-vocabulary-icon" />
                                    <h2>Skit</h2>
                                </button>
                                <button className="learn-vocabulary-content" onClick={() => handleNavigateToModuleQuestions("/take-quiz")}>
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/34.png`} alt="Japan Icon" className="learn-vocabulary-icon" />
                                    <h2>Take Quiz</h2>
                                </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Section */}
      <Footer />
    </div>
  );
}

export default LearnVocabulary;
